var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagZh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#DE2910"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,2 L6.12,5.5 L9.9,5.5 L6.89,7.65 L8.01,11.15 L5,9 L1.99,11.15 L3.11,7.65 L0.1,5.5 L3.88,5.5 Z",
    fill: "#FFDE00",
    transform: "translate(5,3) scale(0.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,2 L6.12,5.5 L9.9,5.5 L6.89,7.65 L8.01,11.15 L5,9 L1.99,11.15 L3.11,7.65 L0.1,5.5 L3.88,5.5 Z",
    fill: "#FFDE00",
    transform: "translate(12,1) scale(0.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,2 L6.12,5.5 L9.9,5.5 L6.89,7.65 L8.01,11.15 L5,9 L1.99,11.15 L3.11,7.65 L0.1,5.5 L3.88,5.5 Z",
    fill: "#FFDE00",
    transform: "translate(14,3) scale(0.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5,2 L6.12,5.5 L9.9,5.5 L6.89,7.65 L8.01,11.15 L5,9 L1.99,11.15 L3.11,7.65 L0.1,5.5 L3.88,5.5 Z",
    fill: "#FFDE00",
    transform: "translate(14,6) scale(0.3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5,2 L6.12,5.5 L9.9,5.5 L6.89,7.65 L8.01,11.15 L5,9 L1.99,11.15 L3.11,7.65 L0.1,5.5 L3.88,5.5 Z",
    fill: "#FFDE00",
    transform: "translate(12,8) scale(0.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagZh);
export default __webpack_public_path__ + "static/media/flag-zh.afa8489454e2bcd0fd01afd06f22fc52.svg";
export { ForwardRef as ReactComponent };